import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import {
  isFieldWrong,
  isFormValid
} from "../../common/lib/validationAllFields";
import {
  addNotificationsForInvalidFields,
  focusInvalidField
} from "../lib/validationWeb";
import Spinner from "../components/spinner.react";
import InputWithError from "../components/inputWithError.react";
import Modal from "../components/modal.react";
import Table from "./table.react";
import { Link } from "react-router";

export default class PagesList extends Component {
  static propTypes = {
    msg: React.PropTypes.object
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.loadPagesListCategories();
  }

  componentDidUpdate(prevProps) {
    const {
      actions,
      pagesLists: {
        forms: {
          createPagesListCategory: { fields }
        }
      }
    } = this.props;
    const {
      pagesLists: {
        forms: {
          createPagesListCategory: { fields: prevFields }
        }
      }
    } = prevProps;

    if (fields.get("name") !== prevFields.get("name")) {
      actions.setFormField(
        "pagesLists",
        "createPagesListCategory",
        "slug",
        this.generateSlug(fields.get("name"))
      );
    }
  }

  generateSlug = name => {
    name = name.replace(/^\s+|\s+$/g, ""); // trim
    name = name.toLowerCase();

    const from = "àáäâąæãåāèéëêęėēìíïîòóöôóõœøōùúüûñçćčśßšłżźžń·/_,:;";
    const to = "aaaaaaaaaeeeeeeeiiiiooooooooouuuuncccssslzzzn------";
    for (var i = 0, l = from.length; i < l; i++) {
      name = name.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    name = name
      .replace(/[^a-z0-9 -]/g, "")
      .replace(/\s+/g, "-")
      .replace(/-+/g, "-");

    return name;
  };

  loadPagesListCategories = () => {
    const {
      actions,
      notificationSystem,
      params: { slug },
      locales: {
        locales: { defaultLocale }
      }
    } = this.props;
    actions.clearForm("pagesLists", "createPagesListCategory");
    actions.getPagesListCategories(slug).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      }
    });
  };

  openAddPagesListCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsAddPagesListCategoryModalVisble(true);
  };

  closeAddPagesListCategoryModal = () => {
    const { actions } = this.props;
    actions.setIsAddPagesListCategoryModalVisble(false);
  };

  createPagesListCategory = () => {
    const {
      actions,
      pagesLists: {
        forms: {
          createPagesListCategory: { fields }
        }
      },
      params: { slug },
      pagesLists: {
        pagesLists: { entities: pagesLists }
      },
      notificationSystem,
      locales: {
        locales: { defaultLocale }
      }
    } = this.props;
    const uid = pagesLists.getIn([slug, "uid"]);
    const data = {
      locale: defaultLocale,
      name: fields.get("name"),
      tag: fields.get("tag"),
      slug: fields.get("slug"),
      description: fields.get("description")
    };
    actions.createPagesListCategory(data, uid).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        this.loadPagesListCategories();
      }
    });
    actions.setIsAddPagesListCategoryModalVisble(false);
  };

  render() {
    const {
      actions,
      pagesLists: { forms },
      msg: { pagesLists: msg },
      params: { slug },
      pagesLists: {
        pagesLists: { entities: pagesLists }
      }
    } = this.props;

    const createPagesListCategoryFormProps = {
      feature: "pagesLists",
      form: forms.createPagesListCategory,
      formName: "createPagesListCategory",
      actions: actions,
      msg: msg.forms.createPagesListCategory,
      validateFormField: actions.validateFormFieldPagesLists
    };

    return (
      <div className="islogged-page">
        <div className="row middle-xs">
          <h2 className="col-xs-8">
            {pagesLists.getIn([slug, "name"])} - kategorie
          </h2>
          <div className="col-xs-4">
            <button
              className="info"
              onClick={this.openAddPagesListCategoryModal}
            >
              dodaj kategorie
            </button>
          </div>
          <div className="col-xs-12">
            <div className="box-wrapper">
              <div className="title">Wszystkie kategorie</div>
              <div className="content-wrapper">
                <Table {...this.props} tableWidth={1000} tableHeight={300} />
              </div>
            </div>
          </div>
        </div>

        {forms.createPagesListCategory.isAddModalVisible && (
          <Modal
            closeModalAction={this.closeAddPagesListCategoryModal}
            enterAction={this.createPagesListCategory}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs">
              <h3>Utwórz nowy wpis:</h3>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="Nazwa"
                  field="name"
                  {...createPagesListCategoryFormProps}
                />
              </div>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="slug"
                  field="slug"
                  {...createPagesListCategoryFormProps}
                />
              </div>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="tag"
                  field="tag"
                  {...createPagesListCategoryFormProps}
                />
              </div>
              <div className="col-xs-12">
                <InputWithError
                  placeholder="opis"
                  field="description"
                  {...createPagesListCategoryFormProps}
                />
              </div>
              <button
                className="success"
                onTouchTap={this.createPagesListCategory}
              >
                Tak
              </button>
              <button
                className="error"
                onTouchTap={this.closeAddPagesListCategoryModal}
              >
                Nie
              </button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/pagesListCategories/pagesListCategories.react.js